import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compact } from "lodash";
import { getResultsTableData, getIsLocal } from "selectors";

import FileIcon from "icons/FileIcon";

import ExportResultsModal from "./ExportResultsModal";

import Table from "components/table/Table";
import DefaultCell from "app/meets/board/cells/DefaultCell";
import NameCell from "./cells/NameCell";
import TeamCell from "./cells/TeamCell";
import PlaceCell from "./cells/PlaceCell";
import AttemptCell from "./cells/AttemptCell";
import ScoreCell from "./cells/ScoreCell";
import CheckIcon from "icons/CheckIcon";

import { getBenchLabel } from "util/meetHelper";

class ResultsTable extends Component {
  state = { showModal: false };

  getAllColumns = () => {
    const federationConfig = this.props.federationConfig;
    const showFourthAttempts = !!federationConfig?.fourthAttempts;

    // prettier-ignore
    return compact([
      {key: 'name', label: 'Name', width: 175, renderer: NameCell},
      {key: 'team', label: 'Team', width: 115, renderer: TeamCell},
      {key: 'place', label: 'Place', width: 55, renderer: PlaceCell},
      {key: 'bodyWeight', label: 'Body Wgt', width: 75, renderer: DefaultCell},
      {key: 'weight', label: 'Squat 1', width: 70, lift: 'squat', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 2', width: 70, lift: 'squat', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 3', width: 70, lift: 'squat', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'weight', label: 'Squat 4', width: 70, lift: 'squat', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 1`, width: 70, lift: 'bench', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 2`, width: 70, lift: 'bench', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 3`, width: 70, lift: 'bench', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'weight', label: `${getBenchLabel(this.props.meet)} 4`, width: 70, lift: 'bench', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'weight', label: 'Dead 1', width: 70, lift: 'dead', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 2', width: 70, lift: 'dead', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 3', width: 70, lift: 'dead', attemptNumber: '3', renderer: AttemptCell},
      showFourthAttempts ? {key: 'weight', label: 'Dead 4', width: 70, lift: 'dead', attemptNumber: '4', renderer: AttemptCell} : undefined,
      {key: 'score', width: 110, renderer: ScoreCell}
    ]);
  };

  getCellLines = (index) => {
    return 1;
  };

  blockExport(exportFunction) {
    if (this.props.forecasted) {
      alert("Can't export results in forecasted mode");
    } else {
      exportFunction();
    }
  }

  openExportResultsModal = () => {
    this.setState({ showModal: true });
  };

  closeExportResultsModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const {
      data,
      isLocal,
      meet,
      setForecasted,
      forecasted,
      showButtons,
      openDonateModal,
    } = this.props;

    const columns = this.getAllColumns();

    return (
      <div style={{ height: "100%" }}>
        {showButtons && (
          <div className="util-row">
            <button
              className="export-button"
              onClick={() =>
                this.blockExport(() => this.openExportResultsModal())
              }
            >
              <FileIcon /> &nbsp; Export
            </button>
            <button className="forecasted" onClick={() => setForecasted()}>
              Forecasted&nbsp;{forecasted && <CheckIcon />}
            </button>
          </div>
        )}
        <div className="table-wrapper">
          <Table
            data={data}
            numberOfFixedLeftColumns={3}
            columns={columns}
            getCellLines={this.getCellLines}
            meet={this.props.meet}
            scrollToAlignment="center"
            media={this.props.media}
            padBottom
          />
        </div>
        <ExportResultsModal
          meet={meet}
          isOpen={this.state.showModal}
          onRequestClose={this.closeExportResultsModal}
          data={data}
          isLocal={isLocal}
          openDonateModal={openDonateModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isLocal: getIsLocal(state, props),
    data: getResultsTableData(state, props),
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(ResultsTable));
